"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoadingTime = void 0;
var getLoadingTime = function () {
    return (window.performance && window.performance.now && Math.round(window.performance.now())) || null;
};
exports.getLoadingTime = getLoadingTime;
//# sourceMappingURL=loadingTime.js.map